import { LucideHelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil';
import { getLanguageValue, webshopConfig } from '~/config/webshopConfig';
import { getLinkRel } from '~/common/utils/urlUtil';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function Help({ className, isAgh }: Readonly<{ className?: string; isAgh: boolean }>) {
  const { t, i18n } = useTranslation();

  return (
    <TrackNavigationClick label={t('Hilfe')}>
      <a
        href={getLanguageValue(i18n.language, isAgh ? webshopConfig.helpLinkAgh : webshopConfig.helpLinkBgh)}
        target={'_blank'}
        rel={getLinkRel(getLanguageValue(i18n.language, isAgh ? webshopConfig.helpLinkAgh : webshopConfig.helpLinkBgh))}
        className={cn(
          'flex items-center hover:text-primary text-black desktop:text-secondary desktop:hover:text-primary desktop:px-2 h-12',
          className
        )}
        data-testid={'help-link'}
      >
        <LucideHelpCircle className={'w-[24px] h-[24px] desktop:w-[18px] desktop:h-[18px]'} />
        <div className={'ml-2 text-base desktop:text-sm desktop:ml-1'}>{t('Hilfe')}</div>
      </a>
    </TrackNavigationClick>
  );
}
